import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { voiceAnalysesActions } from 'features/voiceAnalyses';

const useVoiceAnalyses = () => {
  const dispatch = useDispatch();
  const getVoiceAnalyses = useCallback(({ offset }) => dispatch(voiceAnalysesActions.getVoiceAnalyses({ offset })), [dispatch]);
  const getVoiceAnalysis = useCallback(({ id, cable }) => dispatch(voiceAnalysesActions.getVoiceAnalysis({ id, cable })), [dispatch]);
  const clearLocalVoiceAnalyses = useCallback(() => dispatch(voiceAnalysesActions.clearLocalVoiceAnalyses()), [dispatch]);
  const clearLocalActiveVoiceAnalysis = useCallback(() => dispatch(voiceAnalysesActions.clearLocalActiveVoiceAnalysis()), [dispatch]);

  return {
    getVoiceAnalyses,
    getVoiceAnalysis,
    clearLocalVoiceAnalyses,
    clearLocalActiveVoiceAnalysis
  };
};

export default useVoiceAnalyses;